import pre from './pre';
import cart from './cart.vue';
import config from './config/index.vue';
import success from './success.vue';
import addon from './addon/index.vue';
export default {
  pre,
  components: {
    config,
    cart,
    addon,
    success
  },
};
